import React from 'react';
import { Image, Tag } from 'antd';

export const STATUS_COLORS = { draft: 'default', running: 'processing', completed: 'success' };

export const StatusTag = ({ status }) => <Tag color={STATUS_COLORS[status] || 'default'}>{status}</Tag>;

export const armTotals = (progress, armId) => {
    const p = progress?.byArm?.[armId] || { pending: 0, running: 0, done: 0, failed: 0 };
    return { ...p, total: p.pending + p.running + p.done + p.failed };
};

export const experimentTotals = (experiment) => {
    const totals = { pending: 0, running: 0, done: 0, failed: 0, total: 0 };
    for (const arm of experiment.arms || []) {
        const t = armTotals(experiment.progress, arm.id);
        for (const key of Object.keys(totals)) totals[key] += t[key];
    }
    return totals;
};

export const describeArm = (arm) =>
    arm.kind === 'existing' ? 'existing production output' : `${arm.provider} · ${arm.model}`;

export const formatDate = (val) => (val ? new Date(val).toLocaleString() : '—');

export const pct = (v) => (v == null ? '—' : `${Math.round(v * 100)}%`);
export const num = (v, digits = 2) => (v == null ? '—' : v.toFixed(digits));
export const duration = (ms) => (ms == null ? '—' : ms < 1000 ? `${Math.round(ms)} ms` : `${(ms / 1000).toFixed(1)} s`);

export const describeCriterion = (c) => `${c.label} (${c.min}–${c.max})`;

export const DEFAULT_CRITERIA = [
    { label: 'Accuracy', min: 1, max: 10 },
    { label: 'Beautiful rendering', min: 1, max: 10 },
];

export const RATER_STORAGE_KEY = 'renderExperimentRater';

export const loadRaterName = () => {
    try { return localStorage.getItem(RATER_STORAGE_KEY) || ''; } catch { return ''; }
};

export const saveRaterName = (name) => {
    try { localStorage.setItem(RATER_STORAGE_KEY, name); } catch { /* private mode */ }
};

/** Equal square boxes with `contain` so output-size differences between providers don't leak. */
export const SquareImage = ({ src, alt, size = 260, preview = true }) => (
    <div style={{
        width: size, height: size, background: '#0e1117', borderRadius: 8,
        border: '1px solid rgba(255,255,255,0.12)', display: 'flex', alignItems: 'center',
        justifyContent: 'center', overflow: 'hidden',
    }}>
        <Image
            src={src}
            alt={alt}
            preview={preview}
            width={size}
            height={size}
            style={{ objectFit: 'contain', width: size, height: size }}
        />
    </div>
);
